import React, { useContext, useEffect, useState } from "react";
import auth from "../services/authServices";
import http from "../services/httpServices";
import LoadingIcon from "../components/ui/LoadingIcon";
import CenterIcon from "../components/ui/CenterIcon";
import CommunityCategoryCard from "./CommunityCategoryCard";
import AuthContext from "../context/AuthContext";

import AdminIcon from "../assets/komet-assets/adminIcon.png";
import BgInkPattern from "../assets/komet-assets/bgPattern.png";
import { useLanguage } from "../context/LanguageContext";
const CommunityCategories = ({ type = "card" }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);
    const { language } = useLanguage();
    const [categories, setCategories] = useState([]);

    const { adminToken, token } = useContext(AuthContext);
    const content = {
        loading: {
            en: "Loading groups...",
            ar: "يتم الآن تحميل المجموعات...",
            de: "Lade Gruppen...",
        },
        error: {
            en: "An error occurred",
            ar: "حدث خطأ",
            de: "Ein Fehler ist aufgetreten",
        },
        noGroups: {
            en: "Groups will be added soon",
            ar: "سيتم اضافة المجموعات قريبًا",
            de: "Gruppen werden bald hinzugefügt",
        },
        adminMessage: {
            en: "These are the available groups for your admin account",
            ar: "هذه هي المجموعات المتاحة لحساب المسئول الخاص بك",
            de: "Dies sind die verfügbaren Gruppen für dein Admin-Konto",
        },
        chooseGroup: {
            en: "Choose your",
            ar: "أختار",
            de: "Wähle deine",
        },
        group: {
            en: "Group",
            ar: "مجموعتك",
            de: "Gruppe",
        },
    };

    const getCategories = async () => {
        let config = {};
        if (adminToken) {
            config = auth.getAuthConfig(adminToken);
        } else {
            const token = auth.getToken();
            config = auth.getAuthConfig(token);
        }

        // const { data } = http.get("/");
        try {
            const { data } = await http.get(
                `/api/${adminToken ? "admin/" : ""}visible/community_categories`,
                config
            );
            setCategories({});
            setCategories(data);
            setIsLoading(false);
        } catch (error) {
            setIsError(true);
        }
    };
    useEffect(() => {
        getCategories();
    }, []);
    return (
        <>
            {isLoading ? (
                <div className="flex-center-both py-10">
                    <div
                        className={`bg-cyan-500 rounded-md py-10 px-5 flex-center-both space-x-3 space-x-reverse font-h3 text-slate-50`}
                    >
                        <LoadingIcon className="font-h1" />
                        <span>{content.loading[language]}</span>
                    </div>
                </div>
            ) : isError ? (
                <div className="flex-center-both py-10">
                    <div className="bg-rose-500 rounded-md py-10 px-5 flex-center-both space-x-3 space-x-reverse font-h3 text-slate-50">
                        <CenterIcon icon="ic:twotone-error" className="font-h1 pt-1" />
                        <span>{content.error[language]}</span>
                    </div>
                </div>
            ) : categories.length < 1 ? (
                <div className="flex-center-both py-10">
                    <div className="bg-orange-600 rounded-md py-10 px-5 flex-center-both space-x-3 space-x-reverse font-h3 text-slate-50">
                        <CenterIcon icon="carbon:error" className="font-h1 pt-1" />
                        <span>{content.noGroups[language]}</span>
                    </div>
                </div>
            ) : (
                <div className="flex-center-both flex-col space-y-10 py-5">
                    {adminToken && (
                        <div className="flex-center-both relative overflow-hidden flex-col-reverse gap-5 rounded-lg bg-yellow-100/30 dark:bg-yellow-900/30 border-[1px] border-solid border-black smooth p-10 font-h2 font-w-bold">
                            <div
                                className="absolute inset-0 w-full opacity-50 dark:opacity-20"
                                style={{
                                    backgroundImage: `url(${BgInkPattern})`,
                                    backgroundRepeat: "repeat",
                                    backgroundSize: "contain",
                                }}
                            />
                            <div className="relative z-10 clr-text-primary smooth">
                                {content.adminMessage[language]}
                            </div>
                            <img src={AdminIcon} alt="AdminIconCommunity" className="w-20 h-auto" />
                        </div>
                    )}

                    <div className="flex-center-both flex-col space-y-10 pt-5">
                        <div className="relative">
                            <h1 className="z-10 relative text-center font-dg font-w-bold w-full text-3xl md:text-4xl lg:text-5xl">
                                {content.chooseGroup[language]}{" "}
                                <span className="text-yellow-500">{content.group[language]}</span>
                            </h1>
                        </div>
                    </div>

                    <div className="flex items-center overflow-hidden relative justify-evenly flex-wrap py-10 px-0 md:px-10 gap-8">
                        {categories.map((category) => (
                            <CommunityCategoryCard key={category.id} category={category} />
                        ))}
                    </div>
                </div>
            )}
        </>
    );
};

export default CommunityCategories;
